export default "__VITE_ASSET__BSNFd5NH__"